import { Component } from 'react'
import styled from 'glamorous'
import { map } from 'lodash'

import { $ } from 'utils'
import { Icon, ImagePure } from 'components'


const Container = styled.div({
  position: 'relative',
  width: '100%',
  height: '100%',
  overflow: 'hidden',
}, 'cls-container')

const PhotoList = styled.div({
  display: 'flex',
  flexFlow: 'row wrap',
  alignItems: 'flex-start',
  alignContent: 'flex-start',
  height: '100%'
})

const PhotoContainer = styled.div({
  position: 'relative',
  width: 62,
  height: 80,
  marginLeft: 2,
  marginBottom: 2,
  cursor: 'pointer',
  '&:hover .photo-hover': {
    display: 'flex'
  }
}, ({ isDisabled }) => isDisabled && ({
  opacity: .35,
  cursor: 'default',
}))

const ImageContainer = styled.div({
  position: 'absolute',
})

const PhotoHover = styled.div({
  display: 'none',
  position: 'absolute',
  width: '100%',
  height: '100%',
  justifyContent: 'center',
  alignItems: 'center'
}, ({ isSelected }) => isSelected && ({
  display: 'flex'
}), 'photo-hover')


export default class PhotoListSelector extends Component {

  render = () => {
    const { selected, locked = [], items, onSelect } = this.props
    return (
      $(Container,
        $(PhotoList,
          map(items, (val, key) => {
            const isSelected = map(selected, i => i.uuid).includes(val.uuid)
            const negative = !isSelected && selected.length > 0
            const isDisabled = locked.includes(val.uuid)
            return (
              $(PhotoContainer, { key, onClick: () => !isDisabled && onSelect(val), isDisabled },
                $(ImageContainer,
                  $(ImagePure, {
                    src: val.portrait,
                    width: 62,
                    height: 80,
                    negative: negative || isDisabled,
                  }),
                ),
                !isDisabled &&
                  $(PhotoHover, { isSelected },
                    $(Icon, {
                      type: 'confirm',
                      color: 'rgba(0, 0, 0, .7)',
                      colorHover: 'rgba(0, 0, 0, .7)',
                      isActive: isSelected
                    })
                  )
              )
            )
          })
        )
      )
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/PhotoListSelector.js